<template>
  <table id="paibantable" style="height: calc(100% - 90px)">
    <thead>
      <tr>
        <td>项目</td>
        <td>1</td>
        <td>2</td>
        <td>3</td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>路面保洁</td>
        <td>张三</td>
        <td>李四</td>
        <td>王五</td>
      </tr>
      <tr>
        <td>伸缩缝清理</td>
        <td>张三</td>
        <td>李四</td>
        <td>王五</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  data() {
    return {
      tableData: {
        1: {},
      },
    };
  },
  methods: {},
};
</script>
<style>
#paibantable {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/person/renyuanList.vue